import { Alert, List } from '@mantine/core';
import { ApiError } from '../api/client';
import { errorMessage } from '../features/auth/session';
import { t } from '../texts/pl';

interface DetailItem {
  participant?: string;
  edition?: string;
  otherEdition?: string;
  reason?: string;
  /** Konflikt zmiany zajęć z zapisami (US-305 AC-3). */
  participants?: string[];
}

function detailLine(d: DetailItem): string {
  if (Array.isArray(d.participants)) {
    const label = (d.reason && t.program.conflicts[d.reason]) || d.reason || '';
    return d.participants.length ? `${label}: ${d.participants.join(', ')}` : label;
  }
  return [d.participant, d.edition, d.otherEdition ?? (d.reason === 'age' ? 'wiek 3–18 w roku edycji' : undefined)]
    .filter(Boolean)
    .join(' – ');
}

/** Komunikat z kodu błędu (NFR-U5) i – gdy API je podało – lista osób, edycji lub konfliktów, których dotyczy. */
export function ErrorAlert({ error }: { error: unknown }) {
  const details = error instanceof ApiError && Array.isArray(error.details) ? (error.details as DetailItem[]) : [];
  const lines = [...new Set(details.map(detailLine).filter(Boolean))];
  return (
    <Alert color="red" role="alert">
      {errorMessage(error)}
      {lines.length ? (
        <List size="sm" mt="xs">
          {lines.map((line) => (
            <List.Item key={line}>{line}</List.Item>
          ))}
        </List>
      ) : null}
    </Alert>
  );
}
